import { onSearchTextChanged } from '../actions/publicActions';
import { orchestrator } from 'satcheljs';
import { setSearchText } from '../actions/internalActions';

export default orchestrator(onSearchTextChanged, async actionMessage => {
    const { scenarioId, searchText } = actionMessage;

    // Always set the search text in response to search box text changing.
    setSearchText(searchText, scenarioId);
});
